import "./App.css";
import UseStateCounter from "./Counter/Counter";

function App() {
  return (
    <div className="App">
      <UseStateCounter></UseStateCounter>
    </div>
  );
}

export default App;
